import { getContentFullUrl } from "@/lib/contentUtils";

export interface ParsedPreviewConfig {
  type: "video" | "image" | "audio" | "link" | "split" | "doc" | "dynamic/fromTemplate";
  url: string;
  name?: string;
}

export const parsePreviewConfig = (
  contentType: string,
  contentStorageName: string,
  contentLink: string,
  name: string
): ParsedPreviewConfig => {
  if (contentType.startsWith("image")) {
    return {
      type: "image",
      url: getContentFullUrl(contentStorageName),
    };
  }
  if (contentType.startsWith("audio")) {
    return {
      type: "audio",
      url: getContentFullUrl(contentStorageName),
    };
  }
  if (contentType.startsWith("video")) {
    return {
      type: "video",
      url: getContentFullUrl(contentStorageName),
    };
  }
  if (contentType.startsWith("split")) {
    return {
      type: "split",
      url: "",
      name: name,
    };
  }
  if (contentType.startsWith("application/pdf")) {
    return {
      type: "doc",
      url: getContentFullUrl(contentStorageName),
    };
  }

  if (contentType.startsWith("link")) {
    return {
      type: "link",
      url: contentLink,
    };
  }
  if (contentType === "dynamic/fromTemplate") {
    return {
      type: "dynamic/fromTemplate",
      url: "",
    };
  }
  // Fallback to image
  return {
    type: "image",
    url: getContentFullUrl(contentStorageName),
  };
};
